import { useContext } from 'react';
import { AlertContext } from './context/NotifyMessageContext';

export function useNotifyMessage() {
  const context = useContext(AlertContext);
  if (!context) {
    throw new Error('useAlert must be used within an AlertProvider');
  }

  return context;
}
